import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';

/**
 * Functional guard that triggers the Auth0 logout flow.
 * Replaces the sign-out component — clears local tokens, wipes the
 * user-settings store, and calls auth0.logout() which redirects
 * the browser back to the application origin.
 */
export const signOutGuard: CanActivateFn = () => {
	inject(AuthService).signOut().subscribe();

	// Cancel navigation — Auth0 will redirect the browser after logout.
	return false;
};
